import styled from "styled-components/macro";
import { CategoryCard } from "../../../hooks/api/queries/useCategory";
import { CollectionCard } from "../../pages/category/CollectionCard";
import useMenu from "../../../hooks/api/queries/useMenu";
import { flattenTree } from "../../../utils/constructSlug";

interface Props {
  categoryCards: CategoryCard[];
}

export const Collections = ({ categoryCards }: Props) => {
  const { data } = useMenu();

  return (
    <Ul>
      {categoryCards
        .filter(
          (cat) =>
            (cat.imageDesktop?.path ?? cat.defaultImageDesktop?.path) &&
            (cat.imageMobile?.path ?? cat.defaultImageMobile?.path) &&
            data &&
            flattenTree(data)?.find((e) => e.id === cat.id)
        )
        .map((cat) => (
          <li key={`cat-${cat.slug}`}>
            <CollectionCard category={cat} />
          </li>
        ))}
    </Ul>
  );
};

const Ul = styled.div`
  padding-top: 1.25rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  list-style-type: none;

  > li {
    width: 100%;
  }

  img {
    width: 100%;
  }
`;
